// Full car type names as shown on documents, keyed by the stored car_type code.
// Mirrors backend car_types.json's label_th (data/car_type/car_types.json) - the
// new 28-code registry - instead of the old 14-code dictionary; the brackets
// around the code are dropped on print: "(รย.12) รถ..." -> "รย.12 รถ...".
const CAR_TYPE_NAMES = {
  CT1: '(รย.1) รถยนต์นั่งส่วนบุคคลไม่เกิน 7 คน',
  CT2: '(รย.2) รถยนต์นั่งส่วนบุคคลเกิน 7 คน',
  CT3: '(รย.3) รถยนต์บรรทุกส่วนบุคคล',
  CT4: '(รย.4) รถยนต์สามล้อส่วนบุคคล',
  CT5: '(รย.5) รถยนต์รับจ้างระหว่างจังหวัด',
  CT6: '(รย.6) รถยนต์รับจ้างบรรทุกคนโดยสารไม่เกิน 7 คน',
  CT7: '(รย.7) รถยนต์สี่ล้อเล็กรับจ้าง',
  CT8: '(รย.8) รถยนต์รับจ้างสามล้อ',
  CT9: '(รย.9) รถยนต์บริการธุรกิจ',
  CT10: '(รย.10) รถยนต์บริการทัศนาจร',
  CT11: '(รย.11) รถยนต์บริการให้เช่า',
  CT12: '(รย.12) รถจักรยานยนต์ส่วนบุคคล',
  CT13: '(รย.13) รถแทร็กเตอร์',
  CT14: '(รย.14) รถบดถนน',
  CT15: '(รย.15) รถใช้ในงานเกษตรกรรม',
  CT16: '(รย.16) รถพ่วง',
  CT17: '(รย.17) รถจักรยานยนต์สาธารณะ',
  CT18: '(รย.18) รถยนต์รับจ้างผ่านระบบอิเล็กทรอนิกส์',
  CT110: '(ขส.10) รถโดยสารประจำทาง',
  CT120: '(ขส.20) รถขนาดเล็ก',
  CT130: '(ขส.30) รถโดยสารไม่ประจำทาง',
  CT140: '(ขส.40) รถโดยสารส่วนบุคคล',
  CT150: '(ขส.50) รถบรรทุกส่วนบุคคล',
  CT160: '(ขส.60) รถบรรทุกไม่ประจำทาง',
  CT170: '(ขส.70) รถบรรทุกไม่ประจำทาง',
  CT180: '(ขส.80) รถบรรทุกส่วนบุคคล',
  CT190: '(ขส.90) รถบรรทุกส่วนบุคคล',
  CT900: 'อื่นๆ',
};

// '' when the code is unknown/empty, so callers can simply hide the label.
export function carTypeLabel(carType) {
  const name = CAR_TYPE_NAMES[carType];
  return name ? name.replace(/^\(([^)]+)\)\s*/, '$1 ').trim() : '';
}

// Compact labels for follow-up tables, from the same complete display registry.
export function carTypeRegistrationCode(carType) {
  const name = CAR_TYPE_NAMES[carType];
  if (!name) return '';
  const match = name.match(/^\(([^)]+)\)/);
  return match ? match[1] : name;
}
